import React from 'react';

import { Pnl } from '@components/Common';
import { useText } from '@hooks/useText';
import { IDeal } from '@interfaces/deal';
import { Typography } from '@material-tailwind/react';
import { format } from 'date-fns';

import { roundAmount } from '../../utils/amount';
import { renderAmount, renderPositionSide } from '../../utils/renderers';

type PropsType = {
  deal: IDeal;
  realizedPnl: string;
};

const Position: React.FC<PropsType> = ({ deal, realizedPnl }) => {
  const { t } = useText();

  return (
    <div>
      <div className="flex gap-2 items-center">
        <Typography className="font-bold">{deal.symbol}</Typography>
        {renderPositionSide(deal.side)}
      </div>
      <Typography variant="small" className="font-semibold">
        {t('order.quantity')}: {roundAmount(deal.quantity, 5)}
      </Typography>
      <Typography variant="small" className="font-semibold">
        {t('order.entryPrice')}: {roundAmount(deal.avgEntryPrice, 5)}
      </Typography>
      <Typography variant="small" className="font-semibold">
        {t('order.exitPrice')}: {roundAmount(deal.avgExitPrice, 5)}
      </Typography>
      <Typography
        variant="small"
        className="font-semibold flex gap-1 whitespace-nowrap items-center"
      >
        {t('position.realizedPnl')}: <Pnl pnl={realizedPnl} asset={deal.marginAsset} />
      </Typography>
      <Typography variant="small" className="font-semibold">
        {t('wallet.fee')}: {renderAmount(roundAmount(deal.totalFee, 5), deal.feeAsset)}
      </Typography>{' '}
      <Typography variant="small" className="font-semibold">
        {t('statistic.tradeTime')}: {format(new Date(deal.createdAt), 'MM/dd/yyyy H:mm')}
      </Typography>
    </div>
  );
};

export default React.memo(Position);
